// 用户等级称号
export interface Title {
  id: number;
  name: string;
  description: string;
  requiredExp: number;
  icon?: string;
}

// 成就定义
export interface Achievement {
  id: number;
  name: string;
  description: string;
  condition: string;
  reward: number; // 奖励经验值
  icon?: string;
}

// 用户等级系统
export const titles: Title[] = [
  {
    id: 1,
    name: "法律新手",
    description: "开始了解法律知识",
    requiredExp: 0
  },
  {
    id: 2,
    name: "法学学徒",
    description: "掌握基本法律概念",
    requiredExp: 100
  },
  {
    id: 3,
    name: "法律爱好者",
    description: "对法律产生浓厚兴趣",
    requiredExp: 300
  },
  {
    id: 4,
    name: "法律达人",
    description: "熟悉多个法律领域",
    requiredExp: 600
  },
  {
    id: 5,
    name: "法学精英",
    description: "精通法律知识",
    requiredExp: 1000
  },
  {
    id: 6,
    name: "法律专家",
    description: "在法律领域有深入研究",
    requiredExp: 2000
  }
];

// 成就系统
export const achievements: Achievement[] = [
  {
    id: 1,
    name: "初出茅庐",
    description: "完成第一次答题",
    condition: "完成一次答题",
    reward: 10
  },
  {
    id: 2,
    name: "完美通关",
    description: "一次答题全部回答正确",
    condition: "单次答题100分",
    reward: 50
  },
  {
    id: 3,
    name: "坚持不懈",
    description: "连续7天登录学习",
    condition: "连续登录7天",
    reward: 100
  },
  {
    id: 4,
    name: "法律专家",
    description: "累计答对100题",
    condition: "累计答对100题",
    reward: 200
  }
];

// 经验值计算规则
export const expRules = {
  // 答题获得经验值
  questionExp: {
    easy: 5,      // 简单题经验值
    medium: 10,   // 中等题经验值
    hard: 15      // 困难题经验值
  },
  // 连续答对额外奖励
  comboExp: {
    3: 5,  // 连续答对3题奖励
    5: 10, // 连续答对5题奖励
    7: 15  // 连续答对7题奖励
  },
  // 首次通关奖励
  firstClearExp: 50,
  // 每日首次登录奖励
  dailyLoginExp: 10
}; 